import styled from "styled-components"
import breakpoints from "../../styles/breakpoints"
import Grid from "@material-ui/core/Grid"

export const FaqBlock = styled(Grid)`
  margin-bottom: 40px;
  ${breakpoints.md`
    margin-bottom: 88px;
  `};
`

export const FaqTitle = styled.h5`
  font-weight: 600;
  margin-bottom: 40px;
  color: ${props => props.theme.colors.black900};
`